<div>
  <img src="assets/image/404.png" alt="Page not found" /> <br><h3>Page not found - Please, check the url. Thanks!</h3>
<br>
<h5>Visit the root page <a href="/">here</a>. </h5>
<br><br>
</div>
